// extracted by mini-css-extract-plugin
module.exports = {"placeholderTile":"Placeholder_placeholderTile__rqH7d","container":"Placeholder_container__3ppcZ"};